import { useState} from 'react'
import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    populateAdditionalBranchesData
} from '../../redux/selector/additionalBranchSelector'
import { 
    removeAdditionalBranchApplicationWithId,
    setAdditionalBranchApplicationFromBranchData,
    setAdditionalBranchApplicationsMarkDoNotRenew
} from '../../redux/slice/additionalApplicationsSlice'
import {
    Header, 
    Paragraph, 
    Button,
    LineSeperator,
    NavigationLinkButton,
    ErrorMark
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import TopNavigationBar from "../TopNavigationBar"
import Navigation from "../Navigation"
import BranchDetailsForm from '../../components/BranchDetails/BranchDetails'
import {
    VIEW_MODE_REGULAR,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION,
} from '../../app/constants'
import { replaceUrlParams, ValidateString } from '../../app/utils';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors';
import { IsInternalId } from '../../redux/slice/primaryAgencyApplicationSlice';
import { newBranchApplicationSelect } from '../../redux/selector/newBranchApplicationSelector';

const BranchApplicationDetails = (props) => {
    const{applicationType, applicationMode} = props.match.params
    const {dispatch, newBranchDetails} = props
    const {primaryApplication} = newBranchDetails
    const newBranchApplicationDetailsView = (newBranchDetails[applicationType] ? 
        newBranchDetails[applicationType] : newBranchDetails)

    const [showValidationError, setShowValidationError] = useState(false)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    const defaultBranchDetails = {
        branchName : "",
        address : {
            singleLineAddress : ""
        },
        manager : {
            firstName : "",
            phoneNumber : "",
            emailAddress :""
        }
    };

    let details = [];
    if(newBranchDetails.newBranchApplications &&
        Array.isArray(newBranchDetails.newBranchApplications) &&
        newBranchDetails.newBranchApplications.length > 0) {
        details = newBranchDetails.newBranchApplications
    } else { 
        details = [defaultBranchDetails]
    }

    const [branches, setBranches] = useState(details)

    const [viewMode,setViewMode] = useState(props.viewMode ? 
        props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
            VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    const validateData = () => { 

        for(let i =0; i < branches.length; i++) { 
            const branch = branches[i]
            const {
                branchName,
                address,
                manager
            } = branch

            if(ValidateString(branchName, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR)
                return false

            if(!address)
                return false

            if(ValidateString(address.street, VALIDATION_TYPE.CIVIC_ADDRESS)  !== VALIDATION_ERROR.NO_ERROR)
                return false

            if(ValidateString(address.city, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR)
                return false
            
            if(ValidateString(address.postalCode,VALIDATION_TYPE.CANADA_POSTAL_CODE) !== VALIDATION_ERROR.NO_ERROR)
                return false
            
            if(!manager)
                return false

            if(ValidateString(manager.firstName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false

            if(ValidateString(manager.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER) !== VALIDATION_ERROR.NO_ERROR)
                return false

            if(ValidateString(manager.emailAddress, VALIDATION_TYPE.EMAIL) !== VALIDATION_ERROR.NO_ERROR)
                return false
        }

        return true
    }

    const onNextClick = () => {

        setApplicationSaveError(false)

        if(!validateData()) { 
            setShowValidationError(true)
            return
        }

        setShowValidationError(false)

        dispatch(setAdditionalBranchApplicationFromBranchData({
            branches,
            primaryApplication,
            licencingSubType : (applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
                                                    ? LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
                                                    : LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION) 
        }))
        
        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode, true))
        .then((data) => {
            dispatch(push(replaceUrlParams(newBranchApplicationDetailsView.navigation.next,applicationType, applicationMode)))
        })
        .catch(err => {
            setApplicationSaveError(true)
        })
    }

    const onDetailsChange = ({id, updatedDetails}) => {
        let details = [...branches]
        // can't merge the object as it is, because the structure is different
        let update = Object.assign({},details[id])
        for (const key in updatedDetails) {
            if (Object.hasOwnProperty.call(updatedDetails, key)) {
                const element = updatedDetails[key];
                if(key === "branchName"){
                    update.branchName = element 
                } else if(key === "branchAddress") {
                    update.address = Object.assign({}, update.address, {street : element})
                } else if(key === "branchCity") {
                    update.address = Object.assign({}, update.address, {city : element})
                } else if(key === "branchPostalCode") {
                    update.address = Object.assign({}, update.address, {postalCode : element})
                } else if(key === "branchManagerName") {
                    update.manager = Object.assign({}, update.manager, {firstName : element})
                } else if(key === "phoneNumber") {
                    update.manager =  Object.assign({}, update.manager, {phoneNumber : element})
                } else if(key === "branchManagerEmail") {
                    update.manager =  Object.assign({}, update.manager, {emailAddress : element})
                }
            }
        }
        details.splice(id, 1, update)
        setBranches(details) 
    }

    const branchDetailsComponents = () => {
        let components = []

        branches.forEach((element, index) => {
            components.push(
                <div key={index} className="bottomMarginNormal">
                    <div className="row">
                        <div className={"col-lg-8 bottomMarginNormal"}>
                            <BranchDetailsForm
                                id={index} 
                                onDetailsChange={onDetailsChange}
                                branchName={element.branchName}
                                branchAddress={element.address ? element.address.street : ""}
                                branchCity={element.address ? element.address.city : ""}
                                branchPostalCode={element.address ? element.address.postalCode : ""}
                                branchManagerName={element.manager ? element.manager.firstName : ""}
                                phoneNumber={element.manager ? element.manager.phoneNumber : ""}
                                branchManagerEmail={element.manager ? element.manager.emailAddress : ""} 
                                managerHelperText={newBranchApplicationDetailsView.managerHelperText}
                                showValidationError={showValidationError}
                            />
                        </div>
                        <div className={"col-lg-4"}>
                            {(index > 0) && 
                                <NavigationLinkButton
                                    id={"branch-remove-link"}
                                    text={"- Remove this branch "}
                                    onClick={() => {
                                        let details = [...branches]
                                        const removedBranchDetails = details.splice(index, 1)
                                        // if there is a valid id and its a renewal type application, 
                                        // then we need to revert the changes done for renewal and mark this
                                        // application as do not renew.
                                        if(applicationMode === APPLICATION_MODE_RENEW) {
                                            const branchIds = removedBranchDetails.filter(b => !IsInternalId(b.id)).map(b => b.id)
                                            if(branchIds.length) {
                                                dispatch(setAdditionalBranchApplicationsMarkDoNotRenew({
                                                    branchApplicationIds : branchIds,
                                                }))
                                            }
                                        } else {
                                            if(removedBranchDetails.length) {
                                                removedBranchDetails.forEach(b => dispatch(removeAdditionalBranchApplicationWithId(b.id)))
                                            }
                                        }
                                        setBranches(details)
                                    }}
                                />}
                        </div>
                    </div>
                    <LineSeperator />
                </div>
            )
        })

        return components
    }

    let reviewData = []
    if(viewMode === VIEW_MODE_RENEWAL_PREVIEW)
        reviewData = populateAdditionalBranchesData(branches)

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT 
            && <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <TopNavigationBar {...props} />
                    <div className="row">
                        <div className="col-lg-8">
                            <Header 
                                id="new-branch-details-header"
                                header={newBranchApplicationDetailsView.header} />
                            <Paragraph 
                                id="new-branch-details-text"
                                text={newBranchApplicationDetailsView.text} />
                        </div>
                    </div>
                </>
                }
                <div className="row">
                    <div className="col-lg-8">
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW &&
                        <>
                            {
                                reviewData.map((data, index) => {
                                    return (
                                        <div key={"review-new-branch-data-" + index}>
                                            <ReviewForm data={data} />
                                            {(index < reviewData.length - 1)
                                                && <LineSeperator />} 
                                        </div>
                                    )
                                })
                            }
                        </>
                        }

                        {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                            branchDetailsComponents()
                        }
                    </div>
                </div>
                {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="row bottomMarginMedium">
                        <div className={"col-lg-8"}>
                            <NavigationLinkButton
                                id={"branch-add-more-link"}
                                text={"+ Add another branch "}
                                onClick={() => {
                                    let details = [...branches, defaultBranchDetails]
                                    setBranches(details)
                                }}
                            />
                        </div>
                    </div>
                }
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginNormal">
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button 
                                id="new-branch-save-next"
                                text={"Save and next"}
                                buttonType={"regular_primary"}
                                onClick={onNextClick}
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && <div className="help-block topMarginNormal">
                                {ERROR_STRING.APPLICATION_SAVE_ERROR}
                            </div>}
                        </div>
                        {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <div className="col-lg-4">
                            <NavigationLinkButton 
                                id={"licence-history-details-edit-mode-switch"}
                                text={"Update this information before continuing"}
                                onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                            />
                        </div>}
                    </div>
                </>
                }
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                <>
                    <div className="row bottomMarginNormal">
                        <div className="col-lg-2">
                            <Button 
                                id="new-branch-edit-mode-save"
                                text={"Save"}
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    
                                    if(!validateData()) { 
                                        setShowValidationError(true)
                                        return
                                    }
                            
                                    setShowValidationError(false)

                                    dispatch(setAdditionalBranchApplicationFromBranchData({
                                        branches,
                                        primaryApplication,
                                        licencingSubType : (applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
                                                                                ? LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION
                                                                                : LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION) 
                                    }))

                                    if(props.onEditSave)
                                        props.onEditSave()
                                }}
                            />
                        </div>
                    </div>
            </>
            }
            </div>
        </>
    )
}

export default connect(newBranchApplicationSelect)(BranchApplicationDetails)
